
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import AboutPage from '../pages/about/page';
import FoundersPage from '../pages/founders/page';
import InvestmentThesisPage from '../pages/investment-thesis/page';
import PitchPage from '../pages/pitch/page';
import AcceleratorPlaybookPage from '../pages/accelerator-playbook/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/founders',
    element: <FoundersPage />,
  },
  {
    path: '/investment-thesis',
    element: <InvestmentThesisPage />,
  },
  {
    path: '/pitch',
    element: <PitchPage />,
  },
  {
    path: '/accelerator-playbook',
    element: <AcceleratorPlaybookPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
